import { apiStore } from '../api';

class ClienteService {
  getAll() {
    return apiStore.get(`/api/backoffice/cliente/get/all`);
  }
}
export default new ClienteService();
